import moment from 'moment';
import { CapitalizeNames } from 'src/utils/capitalize';
import { DATE_COLUM_TYPE } from '../constants';
import { TColumnType } from '../components/types';

export /**
 * Will return the string given formatted to the
 * corresponding data type
 *
 * @param {string} string that will be converted
 * @param {TColumnType} type type of the string
 * @return {*}
 */
const formatText = (
    string: string,
    type: TColumnType | undefined,
    isCapitalize: boolean | undefined
) => {
    if (!string) return '- - -';

    switch (type) {
        case DATE_COLUM_TYPE:
            return moment(string).format('ll');
        default:
            return isCapitalize ? CapitalizeNames(string) : string;
    }
};
